import { connector } from "../../utils/common/connector";

const controller = "contractFile";

// ---------------------------------------------
// GET CONTRACT FILES BY CONTRACT ID
// ---------------------------------------------
export const getContractFilesByContractService = async (params) => {
  let reply = { ok: false };

  try {
    const response = await connector.get(
      controller,
      "getContractFileByContractId",
      params,
    );

    reply = {
      contractFiles: response?.contractFiles ?? [],
      totalContractFiles: response?.totalRecords ?? 0,
    };
  } catch (error) {
    console.log(error);
    reply = {
      contractFiles: [],
      totalContractFiles: 0,
    };
  }

  return reply;
};

// ---------------------------------------------
// GET CONTRACT FILE BY ID
// ---------------------------------------------
export const getContractFileByIdService = async (params) => {
  let reply = { ok: false };

  try {
    const response = await connector.get(controller, "getContractFile", params);

    reply = {
      contractFile: response ?? {},
    };
  } catch (error) {
    console.log(error);
    reply = {
      contractFile: {},
    };
  }

  return reply;
};

// ---------------------------------------------
// UPDATE CONTRACT FILE
// ---------------------------------------------
export const updateContractFileService = async (params) => {
  let reply = { ok: false };

  try {
    const { contractFileId, data } = params;

    const cleanData = { ...data };
    delete cleanData._id;

    const response = await connector.post(controller, "updateContractFile", {
      contractFileId,
      data: cleanData,
    });

    reply = {
      contractFile: response ?? {},
    };
  } catch (error) {
    console.log(error);
    reply = {
      contractFile: {},
    };
  }

  return reply;
};

// ---------------------------------------------
// CREATE CONTRACT FILE
// ---------------------------------------------
export const createContractFileService = async (params) => {
  let reply = { ok: false };

  try {
    const response = await connector.post(
      controller,
      "newContractFile",
      params,
    );

    reply = {
      contractFile: response ?? {},
    };
  } catch (error) {
    console.log(error);
    reply = {
      contractFile: {},
    };
  }

  return reply;
};
